import { formatCurrency } from '../../utils/helpers';

// MRR: expected renewal charges per currency. A single currency looks exactly like the
// old figure; mixed currencies get one line each instead of a meaningless sum.
export const RenewalAmounts = ({
  amounts,
  fallback,
}: {
  amounts?: Array<{ currency: string; amount: number }>;
  fallback?: number | null;
}) => {
  if (!amounts?.length) return <span>{fallback === null ? '—' : formatCurrency(fallback ?? 0, 'USD')}</span>;
  return (
    <span>
      {amounts.map((row) => (
        <span className="block" key={row.currency}>
          {formatCurrency(Number(row.amount), row.currency)}
          {amounts.length > 1 && (
            <span className="text-xs text-(--color-muted-gray) font-normal"> {row.currency.toUpperCase()}</span>
          )}
        </span>
      ))}
    </span>
  );
};
